<template>
  <v-layout row class="mt-0">
    <v-flex xs10 offset-xs1>
    <v-card class="layout pa-0">
      <v-card-text class="text">
      <h2>Dashboard</h2>
        <p><router-link to="/upload">Upload file</router-link></p>
        <p> <router-link to="/viewLessons">View scheduled lessons</router-link></p>
        <p> <router-link to="/disallowedDates">Set unavailable lesson dates</router-link></p>
        <hr>
        <p ><router-link to="/signup">Add Student</router-link></p>
        <p> <router-link to="/viewStudents">View/edit students</router-link></p>
        <hr>
        <p @click="setType('Handouts')"><router-link to="/viewItems">View/edit handouts</router-link></p>
        <p @click="setType('Notes')"><router-link to="/viewItems">View/edit notes</router-link></p>
        <p @click="setType('Tracks')"><router-link to="/viewItems">View/edit tracks</router-link></p>
        <p @click="setType('Final Tracks')"><router-link to="/viewItems">View/edit final tracks</router-link></p>
        <hr>
        <p><router-link to="/newSonglist">Add new songlist</router-link></p>
        <p><router-link to="/songlists">View/edit songlists</router-link></p>
        <hr>
        <p><router-link to="/greeting">Add greeting</router-link></p>
        <p @click="setType('Greetings')"><router-link to="/viewItems">View/edit greetings</router-link></p>
        <hr>
        <p><router-link to="/targeted">Add targeted exercise</router-link></p>
        <p @click="setType('Targeted')"><router-link to="/exerciseList">View/edit topics</router-link></p>
      </v-card-text>
    </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  methods: {
    setType(type) {
      this.$store.dispatch("setType", type);
    }
  }
};
</script>

<style scoped>
a {
  color: #3d3d3d;
}
h2 {
  margin-bottom: 25px;
  font-size: 1.4rem;
}

.layout {
  margin-top: 0px;
  padding: 5px;
}

.text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

hr {
  color: rgb(41, 41, 41);
  margin-bottom: 10px;
  width: 95%;
}
</style>